import React from "react";

const AddProcedure = React.createContext();

export default AddProcedure;